import React from 'react';
import MetaFactSubmission from './MetaFactSubmission';

function App() {
  return <MetaFactSubmission />;
}

export default App;